export default __webpack_public_path__ + "a20204067e4638269c3459b045d27f31.svg";